import {Component, Input, OnInit} from '@angular/core';
import {IconProp, SizeProp} from "@fortawesome/fontawesome-svg-core";

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent {
    @Input() icon: IconProp;
    @Input() size: SizeProp = 'lg';
    @Input() fixedWidth: boolean;
    @Input() spin: boolean;
}
